export default function truncateText(text: string, maxLength = 25) {
  if (text.length <= maxLength) {
    return text;
  }

  return text.slice(0, maxLength) + '...';
}
